export const nameBoxStyle = {
  position: 'relative',
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

export const nameTooltipStyle = {
  position: 'absolute',
  maxWidth: '100%',
  whiteSpace: 'nowrap',
  fontSize: '14px',
  fontWeight: 700,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

export const wheatCodeTypographyStyle = {
  fontSize: '0.8rem',
  fontWeight: 600,
}
